import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'groupFidelityReport',
    label: 'Group Fidelity Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
